import { render, staticRenderFns } from "./WorkOrderPage.vue?vue&type=template&id=4f460046&"
import script from "./WorkOrderPage.vue?vue&type=script&lang=js&"
export * from "./WorkOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports